import { Validators } from "@angular/forms";
import {
  IGroup,
  IGroupParams,
} from "@app/shared/data-access/src/lib/resource-management/models/group";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import { TranslationFieldPartialValidator } from "@app/shared/static/fields/fields-constant";
import {
  IHardFormField,
  HardFormFieldTypeEnum,
  IHardFormSelectParams,
  IHardTable,
  HardTableColumnTypeEnum,
  IHardFormFieldParams,
} from "@app/shared/ui-lib/src/lib";
import { IBaseConfig, IFormFieldFilter } from "@models/form/base-config";
import { LangEnum } from "@models/interface-management/localization";

export class GroupConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.Group;
  isCrudByModal = true;
  title = "dicTable.groups";
  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      name: "code",
      title: "dicTable.code",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required],
      },
    },
    {
      name: "division",
      title: "dicTable.division",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + ResourceManagementEndpoints.Division,
        validators: [Validators.required],
      } as IHardFormSelectParams,
    },
    {
      title: "dicTable.sortOrder",
      name: "sortOrder",
      type: HardFormFieldTypeEnum.Number,
    },
  ];

  saveCallback(data: IGroup): IGroup {
    const divisionId = data?.division?.id;

    delete data?.division;

    return {
      ...data,
      divisionId,
    };
  }

  filterTemplateColumns = "1fr 200px";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
    {
      name: "division",
      type: HardFormFieldTypeEnum.Dictionary,
      placeholder: "dicTable.allDivisions",
      outside: true,
      params: {
        dicType: "api/v1/" + ResourceManagementEndpoints.Division,
      } as IHardFormSelectParams,
    },
  ];

  filterCallback(data: IGroupParams): IGroupParams {
    return {
      searchTerm: data?.searchTerm ?? "",
      divisionId: data?.division?.id ?? null,
    };
  }

  tableConfig: IHardTable<IGroup[]> = {
    showDefaultActions: true,
    tableColumns: "44px repeat(4,auto)",
    columns: [
      { name: "index", title: "№", type: HardTableColumnTypeEnum.Index },
      {
        name: "name",
        title: "dicTable.name",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        name: "code",
        title: "dicTable.code",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        name: "name",
        title: "dicTable.divisionName",
        type: HardTableColumnTypeEnum.Parent,
        parent: "division",
      },
    ],
  };
}
